/**
 * Generiert und speichert eine eindeutige Device-ID pro Browser/Gerät.
 * Die ID wird im localStorage gespeichert und bleibt über Sessions hinweg erhalten.
 */
const DEVICE_ID_KEY = "m1member.device.id";

export function getOrCreateDeviceId(): string {
  try {
    if (typeof window === "undefined") return "default";
    
    let deviceId = localStorage.getItem(DEVICE_ID_KEY);
    if (!deviceId) {
      // Generiere eine UUID v4
      deviceId = crypto.randomUUID();
      localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }
    return deviceId;
  } catch {
    // Fallback falls localStorage nicht verfügbar ist
    return "default";
  }
}


